import React, { useContext } from 'react';
import { Button, Flex, FlexItem } from '@patternfly/react-core';
import Bookshelf from 'img/sites_logos/red-hat-training-bookshelf.svg';
import CustomerPortal from 'img/sites_logos/red-hat-customer-portal.svg';
import SkillsAssessment from 'img/sites_logos/red-hat-skills-assessment.svg';
import RedHat from 'img/sites_logos/red-hat-logo.svg';
import { storesContext } from 'stores';

export default function SitesMenu() {
  const { configStore } = useContext(storesContext);
  return (
    <Flex
      justifyContent={{ default: 'justifyContentCenter' }}
      alignItems={{ default: 'alignItemsBaseline' }}
    >
      <FlexItem className="external-site">
        <Button
          variant="link"
          component="a"
          target="_blank"
          href="https://www.redhat.com/"
          data-analytics-id="redhat-btn-header-lp"
        >
          <img src={RedHat} alt="Red Hat" />
        </Button>
      </FlexItem>
      <FlexItem className="external-site">
        <Button
          variant="link"
          component="a"
          target="_blank"
          href="https://access.redhat.com/front"
          data-analytics-id="customer-portal-btn-header-lp"
        >
          <img src={CustomerPortal} alt="Red Hat Customer Portal" />
        </Button>
      </FlexItem>
      <FlexItem className="external-site">
        <Button
          variant="link"
          component="a"
          target="_blank"
          href="https://skills.ole.redhat.com/en"
          data-analytics-id="skills-assessment-btn-header-lp"
        >
          <img src={SkillsAssessment} alt="Red Hat Skills Assessment" />
        </Button>
      </FlexItem>
      {configStore.ebooksPlatformURL && (
        <FlexItem className="external-site">
          <Button
            variant="link"
            component="a"
            target="_blank"
            href={configStore.ebooksPlatformURL}
            data-analytics-id="bookshelf-btn-header-lp"
          >
            <img src={Bookshelf} alt="Red Hat Training Bookshelf" />
          </Button>
        </FlexItem>
      )}
    </Flex>
  );
}
